import { StudentServicePath, WEEKLY_STREAM_SCHEDULE } from "utils/constants";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import ListStreamsWeeklySchedule from "./List";
import CreateStreamWeeklySchedule from "./Create";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AutoAwesomeMotionIcon />,
  name: StudentServicePath + WEEKLY_STREAM_SCHEDULE,
  title: "Занятия в поток",
  list: <ListStreamsWeeklySchedule />,
  create: <CreateStreamWeeklySchedule />,
  createPermission: permissions.canCreateWeeklySchedule,
  permission: permissions.canPreviewWeeklySchedule,
};
